module.exports = __webpack_public_path__ + "img/face-meh.419de69f.svg";